import { WebContentSearchDto } from 'src/app/web-content/shared/dto/web-content-search.dto';
import { SelectItem } from 'primeng/api';
import { WebContentService } from '../shared/web-content.service';
import { WebContentTypeService } from '../shared/web-content-type.service';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { WebContentType } from 'src/app/shared/model/webcontenttype.model';

@Component({
  selector: 'wl-web-content-search-params',
  templateUrl: './web-content-search-params.component.html',
  styleUrls: ['./web-content-search-params.component.less'],
    standalone: false
})
export class WebContentSearchParamsComponent implements OnInit {
  @Output() searchParamsChange: EventEmitter<WebContentSearchDto> = new EventEmitter();
  @Input()
  get searchParams() {
    return this._searchParams;
  }
  set searchParams(value: WebContentSearchDto) {
    this._searchParams = value;
    this.searchParamsChange.emit(this._searchParams);
  }

  webContentTypes: WebContentType[];
  webContentFormats: string[] = [];

  private _searchParams: WebContentSearchDto;

  constructor(private _webContentTypeService: WebContentTypeService, private _webContentService: WebContentService) {}

  ngOnInit(): void {
    this._webContentTypeService.getWebContentTypes().then((typesResult) => {
      this.webContentTypes = typesResult.Result;
    });

    this._webContentService.getWebContentFormats().then((formats) => {
      this.webContentFormats = formats;
    });
  }
}
